export const skills = {
  languages: ["Python", "TypeScript", "Go", "SQL", "JavaScript"],
  frameworks: [
    "React & Next.js",
    "Reflex.dev",
    "FastAPI",
    "Svelte & Sveltekit",
    "Vue.js",
    "Express",
  ],
  frontEnd: [
    "Tailwind",
    "TanStack Query",
    "SASS/SCSS/Stylus",
    "Storybook",
    "Vite",
  ],
  backEnd: [
    "SQLAlchemy & Alembic",
    "Pydantic",
    "Postgres",
    "Redis",
    "OpenFGA",
    "OpenAPI & Fern",
    "OAuth & JWT",
    "SCIM",
  ],
  tooling: [
    "pnpm & Turborepo",
    "Vitest",
    "Playwright",
    "pytest",
    "Testcontainers",
    "Ruff & Pyright",
    "uv & Poetry",
    "Webpack",
    "Git",
  ],
  platform: [
    "Docker",
    "Kubernetes & Helm",
    "GitHub Actions",
    "Cloudflare Workers & D1",
    "AWS",
    "Netlify",
    "Vercel",
    "Sentry",
  ],
};

export default skills;
